(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = (cents / 100);
    var f = format || '${{amount}}';
    var fmt;
    if (/{{\s*amount_no_decimals\s*}}/.test(f)) {
      fmt = Math.round(value).toLocaleString('en-US');
      return f.replace(/{{\s*amount_no_decimals\s*}}/, fmt);
    }
    if (/{{\s*amount_with_comma_separator\s*}}/.test(f)) {
      fmt = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return f.replace(/{{\s*amount_with_comma_separator\s*}}/, fmt);
    }
    fmt = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/{{\s*amount\s*}}/, fmt);
  }

  function init(root) {
    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';

    var tiers = [
      { qty: parseInt(root.dataset.tier1Qty, 10), pct: parseInt(root.dataset.tier1Pct, 10), code: root.dataset.tier1Code || '' },
      { qty: parseInt(root.dataset.tier2Qty, 10), pct: parseInt(root.dataset.tier2Pct, 10), code: root.dataset.tier2Code || '' },
      { qty: parseInt(root.dataset.tier3Qty, 10), pct: parseInt(root.dataset.tier3Pct, 10), code: root.dataset.tier3Code || '' }
    ];

    var giftThreshold = parseInt(root.dataset.giftThreshold, 10) || 0;
    var giftVariantId = root.dataset.giftVariantId || '';
    var giftTitle = root.dataset.giftTitle || '';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-product]'));
    var linesEl = root.querySelector('[data-lines]');
    var subtotalEl = root.querySelector('[data-subtotal]');
    var discountEl = root.querySelector('[data-discount]');
    var discountLabelEl = root.querySelector('[data-discount-label]');
    var discountRow = root.querySelector('[data-discount-row]');
    var totalEl = root.querySelector('[data-total]');
    var nudgeEl = root.querySelector('[data-nudge]');
    var progressFill = root.querySelector('[data-progress-fill]');
    var ticks = Array.prototype.slice.call(root.querySelectorAll('[data-tick]'));
    var rungs = Array.prototype.slice.call(root.querySelectorAll('.pantry-stockup__rung'));
    var checkoutBtn = root.querySelector('[data-checkout]');
    var giftEl = root.querySelector('[data-gift]');
    var giftTextEl = root.querySelector('[data-gift-text]');
    var toastEl = root.querySelector('[data-toast]');

    // state: variantId -> { qty, price, title, image, card }
    var state = {};

    cards.forEach(function (card) {
      var variantId = card.dataset.variantId;
      if (!variantId) return;

      state[variantId] = {
        qty: 0,
        price: parseInt(card.dataset.price, 10),
        title: card.dataset.title,
        image: card.dataset.image,
        url: card.dataset.url,
        card: card
      };

      var qtyInput = card.querySelector('[data-qty]');
      var addBtn = card.querySelector('[data-add]');
      var stepBtns = card.querySelectorAll('[data-step]');

      stepBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = parseInt(btn.dataset.step, 10);
          var next = Math.max(0, (parseInt(qtyInput.value, 10) || 0) + delta);
          qtyInput.value = next;
        });
      });

      qtyInput.addEventListener('change', function () {
        var v = parseInt(qtyInput.value, 10);
        if (isNaN(v) || v < 0) qtyInput.value = 0;
        if (v > 99) qtyInput.value = 99;
      });

      addBtn.addEventListener('click', function () {
        var pending = parseInt(qtyInput.value, 10) || 0;
        var addQty = pending > 0 ? pending : 1;
        state[variantId].qty += addQty;
        qtyInput.value = 0;
        render();
        flashCard(card);
      });
    });

    function flashCard(card) {
      card.classList.add('is-added');
      setTimeout(function () { card.classList.remove('is-added'); }, 1200);
    }

    function totalQuantity() {
      return Object.keys(state).reduce(function (sum, k) { return sum + state[k].qty; }, 0);
    }

    function subtotalCents() {
      return Object.keys(state).reduce(function (sum, k) {
        return sum + (state[k].qty * state[k].price);
      }, 0);
    }

    function currentTier(totalQty) {
      var active = null;
      for (var i = 0; i < tiers.length; i++) {
        if (totalQty >= tiers[i].qty) active = tiers[i];
      }
      return active;
    }

    function nextTier(totalQty) {
      for (var i = 0; i < tiers.length; i++) {
        if (totalQty < tiers[i].qty) return tiers[i];
      }
      return null;
    }

    function renderLines() {
      var html = '';
      Object.keys(state).forEach(function (id) {
        var s = state[id];
        if (s.qty <= 0) return;
        var img = s.image
          ? '<img class="pantry-line__img" src="' + s.image + '" alt="" loading="lazy">'
          : '<div class="pantry-line__img"></div>';
        html +=
          '<li class="pantry-line" data-line-id="' + id + '">' +
            img +
            '<div class="pantry-line__body">' +
              '<p class="pantry-line__title">' + escapeHtml(s.title) + '</p>' +
              '<p class="pantry-line__meta">' + formatMoney(s.price, moneyFormat) + ' each</p>' +
            '</div>' +
            '<div class="pantry-line__controls">' +
              '<button type="button" class="pantry-line__btn" data-line-step="-1" aria-label="Decrease">&minus;</button>' +
              '<span class="pantry-line__qty">' + s.qty + '</span>' +
              '<button type="button" class="pantry-line__btn" data-line-step="1" aria-label="Increase">+</button>' +
            '</div>' +
          '</li>';
      });
      linesEl.innerHTML = html;

      linesEl.querySelectorAll('[data-line-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var li = btn.closest('[data-line-id]');
          var id = li.dataset.lineId;
          var delta = parseInt(btn.dataset.lineStep, 10);
          state[id].qty = Math.max(0, state[id].qty + delta);
          render();
        });
      });
    }

    function renderTotals() {
      var qty = totalQuantity();
      var sub = subtotalCents();
      var tier = currentTier(qty);
      var pct = tier ? tier.pct : 0;
      var discountCents = Math.round(sub * (pct / 100));
      var total = sub - discountCents;

      subtotalEl.textContent = formatMoney(sub, moneyFormat);
      totalEl.textContent = formatMoney(total, moneyFormat);

      if (discountCents > 0) {
        discountRow.hidden = false;
        discountEl.textContent = '−' + formatMoney(discountCents, moneyFormat);
        discountLabelEl.textContent = 'Bundle savings (' + pct + '% off)';
      } else {
        discountRow.hidden = true;
      }

      checkoutBtn.disabled = qty === 0;
    }

    function renderNudge() {
      var qty = totalQuantity();
      var sub = subtotalCents();
      var next = nextTier(qty);

      if (qty === 0) {
        nudgeEl.innerHTML = 'Add a product to start building your bundle.';
      } else if (next) {
        var needed = next.qty - qty;
        var noun = needed === 1 ? 'product' : 'products';
        nudgeEl.innerHTML = 'Add <strong>' + needed + ' more ' + noun + '</strong> to unlock <strong>' + next.pct + '% off</strong>.';
      } else {
        nudgeEl.innerHTML = "You’ve unlocked the best price — <strong>" + tiers[tiers.length - 1].pct + '% off</strong>.';
      }

      if (giftThreshold > 0 && giftVariantId) {
        if (sub >= giftThreshold) {
          giftEl.hidden = false;
          giftTextEl.innerHTML = 'You’ve unlocked a <strong>FREE ' + escapeHtml(giftTitle) + '</strong>! It will be added at checkout.';
        } else if (sub > 0) {
          var remaining = giftThreshold - sub;
          giftEl.hidden = false;
          giftTextEl.innerHTML = 'Spend <strong>' + formatMoney(remaining, moneyFormat) + ' more</strong> to unlock a FREE ' + escapeHtml(giftTitle) + '.';
        } else {
          giftEl.hidden = true;
        }
      }
    }

    function renderProgress() {
      var qty = totalQuantity();
      var topTier = tiers[tiers.length - 1];
      var pctFill = Math.min(100, (qty / topTier.qty) * 100);
      progressFill.style.width = pctFill + '%';

      ticks.forEach(function (tick, i) {
        var t = tiers[i];
        if (qty >= t.qty) tick.classList.add('is-reached');
        else tick.classList.remove('is-reached');
      });

      rungs.forEach(function (rung, i) {
        var t = tiers[i];
        if (qty >= t.qty) rung.classList.add('is-active');
        else rung.classList.remove('is-active');
      });
    }

    function render() {
      renderLines();
      renderTotals();
      renderNudge();
      renderProgress();
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function toast(message) {
      if (!toastEl) return;
      toastEl.textContent = message;
      toastEl.hidden = false;
      requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
      clearTimeout(toast._t);
      toast._t = setTimeout(function () {
        toastEl.classList.remove('is-visible');
        setTimeout(function () { toastEl.hidden = true; }, 250);
      }, 2400);
    }

    checkoutBtn.addEventListener('click', function () {
      var qty = totalQuantity();
      if (qty === 0) return;

      var items = [];
      Object.keys(state).forEach(function (id) {
        if (state[id].qty > 0) {
          items.push({ id: parseInt(id, 10), quantity: state[id].qty });
        }
      });

      var sub = subtotalCents();
      var addGift = giftThreshold > 0 && giftVariantId && sub >= giftThreshold;
      if (addGift) {
        items.push({
          id: parseInt(giftVariantId, 10),
          quantity: 1,
          properties: { _bundle_gift: 'true' }
        });
      }

      var tier = currentTier(qty);
      var code = tier ? tier.code : '';

      checkoutBtn.classList.add('is-loading');

      fetch((window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok) {
            var msg = (res.body && (res.body.description || res.body.message)) || 'Something went wrong adding to cart.';
            throw new Error(msg);
          }

          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: res.body, addToCartBtn: checkoutBtn }
          }));

          if (code) {
            var redirect = (window.theme && window.theme.routes && window.theme.routes.cartPage) || '/cart';
            window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
          } else {
            window.location.href = (window.theme && window.theme.routes && window.theme.routes.cartPage) || '/cart';
          }
        })
        .catch(function (err) {
          checkoutBtn.classList.remove('is-loading');
          toast(err.message || 'Could not add to cart. Please try again.');
        });
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-pantry-stockup]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-pantry-stockup]');
    if (section) init(section);
  });
})();
